// @ts-nocheck b97cf287
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import * as util from '#packages/util';
import mobileThumbnail from './mobileThumbnail';
import { Composites, TextLabel, Thumbnails } from '@wix/wix-base-ui';
import styles from './mobileWizardSingleStep.scss';
const PATH_TO_IMAGES = 'mobileEditor/mobileWizard';

//TYPE WAS GENERATED, remove this line when reviewed
interface Props {
  headerLabel?: string;
  actionToTakeLabel?: string;
  options?: Array<AnyFixMe>;
  onOptionSelected?: FunctionFixMe;
}

export default class extends React.Component<Props> {
  static displayName = 'mobileWizardSingleStep';

  static propTypes = {
    headerLabel: PropTypes.string,
    actionToTakeLabel: PropTypes.string,
    options: PropTypes.array,
    onOptionSelected: PropTypes.func,
  };

  getThumbnails = () => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/map
    return _.map(this.props.options, (option) => {
      const src = util.media.getMediaUrl(
        `${PATH_TO_IMAGES}/${option.imageSrc}`,
      );
      const isSelected = !!option.isSelected;
      const illustration = React.createElement(mobileThumbnail, {
        src,
        isSelected,
      });

      return {
        value: option,
        automationId: option.automationId,
        key: option.label,
        label: option.label,
        illustration,
      };
    });
  };

  render() {
    return (
      <div
        data-aid={this.props.automationId}
        className={styles.mobileWizardSingleStep}
      >
        <div className={styles.stepHeaderWrapper}>
          <TextLabel
            value={this.props.headerLabel}
            enableEllipsis={false}
            type="T13"
            className={styles.stepHeader}
          />

          <TextLabel
            value={this.props.actionToTakeLabel}
            enableEllipsis={false}
            type="T03"
            className={styles.stepSubHeader}
          />
        </div>

        <Composites.Thumbnails>
          <Thumbnails
            onChange={this.props.onOptionSelected}
            shouldAddTooltipOnEllipsis={true}
            hasBackground={false}
            maxThumbsPerRow={4}
            options={this.getThumbnails()}
            className={styles.mobileWizardThumbnails}
          />
        </Composites.Thumbnails>
      </div>
    );
  }
}
